// @flow
import * as React from 'react';
import {
  actionAsideSection as actionAsideSectionCss,
  actionAsideSectionHeading as actionAsideHeadingCss,
  actionAsideHr,
} from './ActionAside.scss';

type ActionAsideSectionProps = {
  heading?: string,
  children: React.Node,
};

const ActionAsideSection = (props: ActionAsideSectionProps) => (
  <div className={actionAsideSectionCss}>
    {props.heading && (
      <h3 className={actionAsideHeadingCss}>{props.heading}</h3>
    )}
    {props.children}
  </div>
);

const ActionAsideSectionFirst = (props: ActionAsideSectionProps) => {
  const { children, ...rest } = props;

  return (
    <ActionAsideSection {...rest}>
      {props.children}
      <hr className={actionAsideHr} />
    </ActionAsideSection>
  );
};

ActionAsideSection.First = ActionAsideSectionFirst;

export default ActionAsideSection;



// WEBPACK FOOTER //
// ./src/components/ModerationCard/PowerReviewsModerationCard/ActionAsideSection.js